import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-374d5218"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "position-table" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-title" }, "持仓", -1))
const _hoisted_3 = { class: "action-links" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "tag-text-cell"
}
const _hoisted_8 = {
  key: 0,
  class: "tag-badge"
}
const _hoisted_9 = {
  key: 1,
  class: "tag-text"
}
const _hoisted_10 = { class: "tip-header" }
const _hoisted_11 = ["src", "onClick"]
const _hoisted_12 = { class: "two-lines-cell" }
const _hoisted_13 = { class: "tip-header" }
const _hoisted_14 = ["src", "onClick"]
const _hoisted_15 = {
  key: 1,
  class: "no-data-table"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "no-data-text" }, "暂无数据", -1))


import { ElMessageBox } from 'element-plus'
import InfoIcon from '@/assets/images/home/info1.svg'
import NoDataIcon from '@/assets/images/home/noData.svg'
import type { TableColumn } from './hooks/useAccountDetail'


export default /*#__PURE__*/_defineComponent({
  __name: 'PositionTable',
  props: {
    columns: null,
    tableData: null,
    loading: { type: Boolean }
  },
  emits: ['buy', 'sell'],
  setup(__props: any) {





const handleTipClick = (col: TableColumn) => {
  ElMessageBox.alert(col.tipContent || '', '免责声明', {
    confirmButtonText: '我知道了',
    customClass: 'message-info',
    showClose: false,
    center: true
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (__props.tableData && __props.tableData.length)
      ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          key: 0,
          data: __props.tableData,
          style: {"width":"100%"},
          "max-height": "300px",
          "row-class-name": "table-row-hover",
          "header-cell-style": { background: '#f7f7f9', color: '#0F1423' }
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (col) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: col.prop + col.label
              }, [
                (col.type === 'action')
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      label: col.label,
                      "min-width": col.minWidth,
                      fixed: col.fixed,
                      align: col.align
                    }, {
                      default: _withCtx(({ row }) => [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("span", {
                            class: "link-buy",
                            onClick: ($event: any) => (_ctx.$emit('buy', row))
                          }, "买入", 8, _hoisted_4),
                          _createElementVNode("span", {
                            class: "link-sell",
                            onClick: ($event: any) => (_ctx.$emit('sell', row))
                          }, "卖出", 8, _hoisted_5)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "min-width", "fixed", "align"]))
                  : (col.type === 'tagWithText')
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 1,
                        label: col.label,
                        "min-width": col.minWidth,
                        fixed: col.fixed,
                        align: col.align
                      }, {
                        default: _withCtx(({ row }) => [
                          (col.propList && col.separator)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(col.propList.map(item => row[item.prop]).filter(Boolean).join(col.separator)), 1))
                            : (col.propList)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.propList, (item) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                      key: item.prop
                                    }, [
                                      (item.style === 'tag')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(row[item.prop]), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(row[item.prop]), 1))
                                    ], 64))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["label", "min-width", "fixed", "align"]))
                    : (col.type === 'twoLines')
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 2,
                          "min-width": col.minWidth,
                          fixed: col.fixed,
                          align: col.align
                        }, {
                          header: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("span", null, _toDisplayString(col.label), 1),
                              (col.showTip)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _unref(InfoIcon),
                                    class: "tip-header-icon",
                                    alt: "info",
                                    onClick: _withModifiers(($event: any) => (handleTipClick(col)), ["stop"])
                                  }, null, 8, _hoisted_11))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          default: _withCtx(({ row }) => [
                            _createElementVNode("div", _hoisted_12, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.propList, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: item.prop
                                }, _toDisplayString(row[item.prop]), 1))
                              }), 128))
                            ])
                          ]),
                          _: 2
                        }, 1032, ["min-width", "fixed", "align"]))
                      : (col.showTip)
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 3,
                            prop: col.prop,
                            "min-width": col.minWidth,
                            fixed: col.fixed,
                            align: col.align
                          }, {
                            header: _withCtx(() => [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("span", null, _toDisplayString(col.label), 1),
                                _createElementVNode("img", {
                                  src: _unref(InfoIcon),
                                  class: "tip-header-icon",
                                  alt: "info",
                                  onClick: _withModifiers(($event: any) => (handleTipClick(col)), ["stop"])
                                }, null, 8, _hoisted_14)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["prop", "min-width", "fixed", "align"]))
                        : (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 4,
                            prop: col.prop,
                            label: col.label,
                            "min-width": col.minWidth,
                            fixed: col.fixed,
                            align: col.align
                          }, null, 8, ["prop", "label", "min-width", "fixed", "align"]))
              ], 64))
            }), 128))
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, __props.loading]
        ])
      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("img", {
            src: _unref(NoDataIcon),
            alt: "no data",
            class: "no-data-icon"
          }, null, 8, _hoisted_16),
          _hoisted_17
        ]))
  ]))
}
}

})